import { WhatsAppButton } from "./WhatsAppButton";

export const WhatsAppCTA = ({
  title = "In 2 Minuten wissen, ob es passt",
  subtitle = "Schreib uns unverbindlich auf WhatsApp. Wir prüfen sofort, ob in deiner Region Überführungen frei sind – kostenlos und ohne Papierkram.",
  label = "Auf WhatsApp starten",
  testid = "cta-section-whatsapp",
}) => {
  return (
    <section className="relative px-4 py-14 sm:px-6 sm:py-16">
      <div className="relative mx-auto max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-[#0D131F] p-7 text-center shadow-2xl sm:p-10">
        <div className="pointer-events-none absolute -inset-24 bg-[#3B82F6]/10 blur-3xl" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-[#60A5FA]">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[#25D366]" />
            </span>
            Direkte Antwort per WhatsApp
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-white sm:text-3xl md:text-4xl">{title}</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-gray-300 sm:text-base">{subtitle}</p>
          <div className="mt-7 flex justify-center">
            <WhatsAppButton size="lg" testid={testid} label={label} pulse />
          </div>
          <p className="mt-4 text-[12px] text-gray-500">Kostenlos & unverbindlich · Keine Gebühren</p>
        </div>
      </div>
    </section>
  );
};
